import React from 'react'
import TwoColumnLayout, { ColumnWrapOrder } from 'components/TwoColumnLayout'
import Line from 'components/Line'
import SectionLink from 'components/SectionLink'
import Shadow from 'components/Shadow'
import H3 from 'components/H3'
import SectionBody1 from 'components/SectionBody1'
import StaticImageWrapper from '../components/StaticImageWrapper'
import { StaticImage } from 'gatsby-plugin-image'

const TakeActionSection = () => {
    return (
        <TwoColumnLayout leftCol={5} rightCol={6} columnWrapOrderOnMobile={ColumnWrapOrder.NORMAL}>
            <Shadow>
                <StaticImageWrapper
                    placeholder={
                        'https://assets.lune.co/lune-co/placeholders/procurement-projects.svg'
                    }
                >
                    <StaticImage
                        placeholder={'dominantColor'}
                        quality={100}
                        src={'../images/ProcurementAction.png'}
                        alt={'Standout'}
                        layout="fullWidth"
                    />
                </StaticImageWrapper>
            </Shadow>

            <>
                <H3>Take action and make supply chains carbon neutral by default</H3>
                <SectionBody1>
                    Make it easy and effortless for your customers to offset their vendors and
                    supply chain emissions through your business in just a few clicks — with all
                    carbon projects vetted for trust and quality.
                </SectionBody1>

                <Line />

                <SectionLink text={'Explore our projects'} to={'/projects'} />
            </>
        </TwoColumnLayout>
    )
}

export default TakeActionSection
